import { TARGET, canJoin, dayNo, fmt, goldQty, reward, streakLive } from '../campaign';
import { BRANDS } from './VouchersSection';

const Arrow = () => (
  <svg viewBox="0 0 24 24"><path d="M4 12h15M13 6l6 6-6 6" /></svg>
);

export function Scrim({ on, onClose }) {
  return <div className={'gfg-scrim' + (on ? ' gfg-on' : '')} onClick={onClose} />;
}

/* ---------------- ₹80-off voucher list ---------------- */
export function VouchersSheet({ on, S, voucher, claimed, onBuy }) {
  const line = S.hasCard
    ? 'Valid on orders above ₹' + fmt((voucher && (voucher.minOrderAmount ?? voucher.payableAbove)) || 800) + ' · ' + ((voucher && voucher.statusText) || 'Physical card holders only')
    : "You'll need a GoSats physical card to redeem these";
  return (
    <div className={'gfg-sheet' + (on ? ' gfg-on' : '')}>
      <div className="gfg-grab" />
      <h3>₹80 off, on us</h3>
      <p>{line}</p>
      <div style={{ marginTop: 8 }}>
        {BRANDS.map(([name, logo]) => (
          <button key={name} className="gfg-vitem" onClick={() => onBuy(name)}>
            <div className="gfg-vlogo"><img src={logo} alt="" /></div>
            <div>
              <div className="gfg-n">{name} voucher</div>
              <div className="gfg-s">₹80 off over ₹800</div>
            </div>
            <span className="gfg-go" style={claimed.has(name) ? { color: '#9D8F83' } : undefined}>
              {claimed.has(name) ? 'Added' : 'Buy'}
            </span>
          </button>
        ))}
      </div>
    </div>
  );
}

/* ---------------- streak earnings / reward ---------------- */
export function EarningsSheet({ on, S, earnings, onCta }) {
  /* API-driven variant: title, subtitle, rows and CTA all come from resp.independence */
  if (earnings) {
    const rows = earnings.details || [];
    const cta = earnings.cta;
    return (
      <div className={'gfg-sheet' + (on ? ' gfg-on' : '')}>
        <div className="gfg-grab" />
        <h3>{earnings.title}</h3>
        <p>{earnings.subTitle}</p>
        <div style={{ marginTop: 16 }}>
          {rows.map((r, i) => (
            <div className="gfg-rowline" key={i}>
              <span style={r.key && r.key.color ? { color: r.key.color } : undefined}>{r.key && r.key.text}</span>
              <b style={r.value && r.value.color ? { color: r.value.color } : undefined}>{r.value && r.value.text}</b>
            </div>
          ))}
        </div>
        {cta && (
          <button className={'gfg-cta' + (cta.enabled === false ? ' gfg-dead' : '')} onClick={() => onCta(cta.action)}>
            <span>{cta.text}</span>
            <Arrow />
          </button>
        )}
      </div>
    );
  }

  const r = reward(S);
  const status = S.broken ? 'Forfeited · 2 missed days'
    : S.claim === 'credited' ? 'Credited to SuperCoins'
    : S.claim === 'claimed' ? 'Claimed · credits within 24h'
    : S.claim === 'claimable' ? 'Ready to claim'
    : 'Locked until ' + TARGET + ' SIPs';
  const statusColor = S.broken ? 'var(--red)' : (S.claim !== 'none' ? 'var(--green)' : 'var(--ink)');
  const ctaLabel = S.claim === 'claimable' ? 'Claim ₹' + fmt(r)
    : (S.claim === 'claimed' || S.claim === 'credited') ? 'View in wallet'
    : S.broken ? 'Buy gold at 5% back' : 'Keep the streak going';
  return (
    <div className={'gfg-sheet' + (on ? ' gfg-on' : '')}>
      <div className="gfg-grab" />
      <h3>{S.claim === 'none' ? 'Your streak earnings' : 'Your reward'}</h3>
      <p>
        {S.broken
          ? 'Streak ended after 2 missed days'
          : S.done >= TARGET
            ? 'Streak complete · Go For Gold'
            : 'Day ' + dayNo(S) + ' of ' + S.window + ' · Go For Gold'}
      </p>
      <div style={{ marginTop: 16 }}>
        <div className="gfg-rowline"><span>Gold bought this streak</span><b>₹{fmt(S.invested)}</b></div>
        <div className="gfg-rowline"><span>Days completed</span><b>{S.done} of {TARGET} SIPs · day {dayNo(S)} of {S.window}</b></div>
        <div className="gfg-rowline"><span>2% streak reward</span><b style={{ color: 'var(--green)' }}>₹{fmt(r)}</b></div>
        <div className="gfg-rowline"><span>5% back in SuperCoins</span><b style={{ color: 'var(--green)' }}>₹{fmt(Math.round(S.invested * 0.05))}</b></div>
        <div className="gfg-rowline"><span>Reward status</span><b style={{ color: statusColor }}>{status}</b></div>
      </div>
      <button className="gfg-cta" onClick={() => onCta()}>
        <span>{ctaLabel}</span>
        <Arrow />
      </button>
    </div>
  );
}

/* ---------------- confirm purchase ---------------- */
export function ConfirmSheet({ on, S, amount, paying, onPay, onCancel }) {
  const showStreakRow = !(S.broken || (!streakLive(S) && !canJoin(S)));
  const streakText = !S.joined
    ? 'Starts your day 1 of ' + S.window
    : 'SIP ' + (S.done + 1) + ' of ' + TARGET + ' · day ' + dayNo(S) + ' of ' + S.window;
  return (
    <div className={'gfg-sheet' + (on ? ' gfg-on' : '')}>
      <div className="gfg-grab" />
      <h3>Confirm your gold purchase</h3>
      <p>Go For Gold offer applied</p>
      <div style={{ marginTop: 16 }}>
        <div className="gfg-rowline"><span>Amount</span><b>₹{fmt(amount)}</b></div>
        <div className="gfg-rowline"><span>24K gold you'll get</span><b>{goldQty(amount)}</b></div>
        <div className="gfg-rowline"><span>5% back in SuperCoins</span><b style={{ color: 'var(--green)' }}>₹{fmt(Math.round(amount * 0.05))}</b></div>
        <div className="gfg-rowline"><span>Delivery</span><b>Free, doorstep</b></div>
        {showStreakRow && (
          <div className="gfg-rowline"><span>Streak</span><b>{streakText}</b></div>
        )}
      </div>
      <button className="gfg-cta" onClick={onPay} style={paying ? { pointerEvents: 'none' } : undefined}>
        <span>{paying ? <i className="gfg-spin" /> : 'Pay ₹' + fmt(amount)}</span>
      </button>
      <button className="gfg-subtle" onClick={onCancel}>Cancel</button>
    </div>
  );
}

/* ---------------- plain purchase success ---------------- */
export function SuccessSheet({ on, info, onDone }) {
  return (
    <div className={'gfg-sheet' + (on ? ' gfg-on' : '')}>
      <div className="gfg-grab" />
      <div className="gfg-tick">
        <svg viewBox="0 0 24 24"><path d="M4 12.5l5 5L20 6.5" /></svg>
      </div>
      <h3>{info.title}</h3>
      <p>{info.body}</p>
      <div style={{ marginTop: 16 }}>
        <div className="gfg-rowline"><span>Streak</span><b>{info.streak}</b></div>
        <div className="gfg-rowline"><span>SuperCoins earned</span><b style={{ color: 'var(--green)' }}>{info.back}</b></div>
        <div className="gfg-rowline"><span>Next SIP</span><b>{info.next}</b></div>
      </div>
      <button className="gfg-cta" onClick={onDone}><span>Done</span></button>
    </div>
  );
}

/* ---------------- claim the 2% ---------------- */
export function ClaimSheet({ on, S, claimInfo, rewardPref, claiming, onClaim }) {
  const r = reward(S);
  const creditLabel = rewardPref === 'GOLD' ? 'Gold, in your wallet' : 'Sats, in your wallet';
  const expiry = claimInfo && claimInfo.available && claimInfo.secondsLeft > 0
    ? 'Claim within ' + Math.max(1, Math.ceil(claimInfo.secondsLeft / 3600)) + ' hours — unclaimed rewards expire.'
    : 'Claim before Aug 29th. Unclaimed rewards expire after that.';
  return (
    <div className={'gfg-sheet' + (on ? ' gfg-on' : '')}>
      <div className="gfg-grab" />
      <h3>Claim your 2% reward</h3>
      <p>7 of 7 daily SIPs done. Here's what you've earned.</p>
      <div style={{ marginTop: 16 }}>
        <div className="gfg-rowline"><span>Gold bought over 7 days</span><b>₹{fmt(S.invested)}</b></div>
        <div className="gfg-rowline"><span>2% streak reward</span><b style={{ color: 'var(--green)' }}>₹{fmt(r)}</b></div>
        <div className="gfg-rowline"><span>Credited as</span><b>{creditLabel}</b></div>
        <div className="gfg-rowline"><span>Credit window</span><b>Within 24 hours of claiming</b></div>
      </div>
      <button className="gfg-cta" onClick={onClaim} style={claiming ? { pointerEvents: 'none' } : undefined}>
        <span>{claiming ? <i className="gfg-spin" /> : 'Claim ₹' + fmt(r)}</span>
      </button>
      <span className="gfg-subtle">{expiry}</span>
    </div>
  );
}
